/*
 * @Author: Tina Huang
 * @Date: 2024-02-18 11:09:29
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-03-15 11:03:19
 * @Description:
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
// import pageCounter from './pageCounter'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// pageCounter()
